import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import React, { useRef, useState } from 'react';
import { useUnitBands } from '../../pages/host/view-rental/useUnitBands';
import dataGridStyle from './dataGrid.module.css';
import useColumnDefs, { defaultColDef } from './useColumnDefs';

interface UnitBandsGridProps {
  address: string;
}
export default function UnitBandsGrid({
  address,
}: UnitBandsGridProps): React.ReactElement {
  const gridRef = useRef<AgGridReact>(null);
  const [itemsPerPage, setItemsPerPage] = useState<number>(25);
  const { unitBands } = useUnitBands(address);
  const columnDefs = useColumnDefs();

  return (
    <div>
      <div className={dataGridStyle.topLine}>
        <input
          type="search"
          className={dataGridStyle.gridSearch}
          onChange={e => {
            gridRef.current?.api.setQuickFilter(e.target.value);
          }}
          placeholder="Search anything here .."
        />

        {/*<button onClick={onBtnExport}>Download CSV </button>*/}
        <button
          className={dataGridStyle.btnExport}
          onClick={() => {
            // setOpen(true);
            gridRef.current?.api.exportDataAsCsv();
          }}
        >
          Export Unit Bands
        </button>
      </div>
      <div className={dataGridStyle.paginationBox}>
        <label htmlFor="page-num-inpt">
          Show
          <select
            className={dataGridStyle.selectBox}
            value={itemsPerPage}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
              setItemsPerPage(Number.parseInt(e.target.value, 10));
            }}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
          Per Page
        </label>
      </div>
      <div className={dataGridStyle.radiusBox}>
        <div
          className="ag-theme-alpine"
          style={{ height: '100%', width: '100%', overflow: 'scroll' }}
        >
          <AgGridReact
            rowData={unitBands}
            rowSelection={'multiple'}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            enableCellTextSelection={true}
            ensureDomOrder={true}
            animateRows={true}
            pagination={true}
            paginationPageSize={itemsPerPage}
            // paginationAutoPageSize
            ref={gridRef}
          ></AgGridReact>
        </div>
      </div>
    </div>
  );
}
